import Tree from './tree';
import createControl from './control';
import makeTreeNode from './make';

var MtdTree = createControl('MtdTree', Tree);
/* istanbul ignore next */
MtdTree.install = function (Vue) {
  Vue.component(MtdTree.name, MtdTree);
};
export { makeTreeNode };

// 对外暴露, 已有项目在使用
MtdTree.withControl = createControl;
MtdTree.makeTreeNode = makeTreeNode;

export default MtdTree;